export const DEL = "DEL";
export const COL = "COL";
export const DELIVERY_SEARCH = "Delivery Search";
export const COLLECTION_SEARCH = "Collection Search";
export const COLLECTIONS = "Collections";
export const DELIVERIES = "Deliveries";
